import { render, staticRenderFns } from "./FileItem.vue?vue&type=template&id=0a43ce02&"
import script from "./FileItem.vue?vue&type=script&lang=ts&"
export * from "./FileItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports